import { render, staticRenderFns } from "./RedemptionOfUrn.vue?vue&type=template&id=6bbf5724&"
import script from "./RedemptionOfUrn.vue?vue&type=script&lang=js&"
export * from "./RedemptionOfUrn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports